<app-header></app-header>
<div class="layout__main-content">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
